import React from "react";
import useMoveTo from "../constants/navigation";
import { ROUTES } from "../App";

const MonthlyChallenge = ({ currentUser, challenge }) => {
    const navigate = useMoveTo();
    const hasActiveChallenge = Boolean(challenge);

    const handleApply = () => {
        navigate(ROUTES.APPLY_CHALLENGE, {
            state: {
                challengeId: challenge.id,
                challenge
            }
        });
    };

    const hasApplied = (() => {
        if (!currentUser || !challenge?.applications) return false;

        // If array format
        if (Array.isArray(challenge.applications)) {
            return challenge.applications.some(app => app.userId === currentUser.uid);
        }

        // If object format (Firebase best practice)
        return Object.values(challenge.applications).some(
            app => app.userId === currentUser.uid
        );
    })();

    return (
        <div className="mb-3 md:mb-8">
            <div className="border border-[#327691] bg-[#EAF4F8] dark:bg-[#1F2E33] rounded-xl p-3 md:p-6">
                <div className="flex flex-row justify-between items-center gap-4">
                    {/* LEFT SIDE */}
                    <div className="flex-1">
                        <h3 className="text-[14px] md:text-[16px] font-bold mb-2">
                            {challenge?.title || "No Active Challenge"}
                        </h3>
                        <p className="mb-3 text-xs md:text-sm">
                            {challenge?.description}

                        </p>
                        <div className="flex items-center gap-2 md:gap-1 mb-1">
                            <span className="text-xs md:text-sm"> 🏆 </span>
                            <span className="font-bold text-xs md:text-sm"> Prize </span>
                            <span className="text-gray-400 text-xs md:text-sm" > {challenge?.prize?.value ? (challenge.prize.type === "cash" ? `R${challenge.prize.value}` : `${challenge.prize.value}`) : ""} </span>
                        </div>
                        <div className="flex items-center gap-2 md:gap-1 mb-1">
                            <span className=" text-xs md:text-sm"> ⏳ </span>
                            <span className="font-bold text-xs md:text-sm"> Deadline </span>
                            <span className="text-gray-400 text-xs md:text-sm">
                                {challenge?.deadline ? new Date(challenge.deadline).toLocaleString() : ""}
                            </span>
                        </div>
                        <div className="flex items-center gap-2 md:gap-1 mb-1">
                            <span className=" text-xs md:text-sm"> 👥 </span>
                            <span className="font-bold text-xs md:text-sm"> Participants </span>
                            <span className="text-gray-400 text-xs md:text-sm" >
                                {challenge?.applications
                                    ? Array.isArray(challenge.applications)
                                        ? challenge.applications.length
                                        : Object.keys(challenge.applications).length
                                    : 0} </span>
                        </div>
                    </div>
                    {/* RIGHT SIDE BUTTON */}
                    {hasActiveChallenge && (
                        <div>
                            <button
                                onClick={handleApply}
                                disabled={
                                    hasApplied || challenge?.status === "closed"
                                }
                                className={`px-3 py-1.5 md:px-5 md:py-2 rounded-xl font-semibold text-[13px] md:text-sm whitespace-nowrap bg-white text-[#327691]
        ${hasApplied
                                        ? "cursor-not-allowed"
                                        : ""
                                    }
        disabled:opacity-60
    `}
                            >
                                {hasApplied ? "Applied" : challenge?.status === "closed" ? "Closed" : "Apply Now"}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};



export default MonthlyChallenge;